export const PokemonSeries: {[seriesId: number]: string} = {
    1: 'BWシリーズ',
    2: 'XYシリーズ',
    3: 'サン&ムーンシリーズ',
    4: 'ソード&シールドシリーズ',
    5: 'スカーレット&バイオレットシリーズ',
    39: 'LEGENDシリーズ',
    40: 'Classicシリーズ',
} as const
